const oneOfGroup = (user, groups) => {
  if (!user || !user.groups) {
    return false;
  }
  return groups.some((group) => (user.groups || []).includes(group));
};

export { oneOfGroup };
//# sourceMappingURL=group.js.map
